import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  height: 32px !important;
  width: 106px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.NL800};
  align-items: center;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    padding-bottom: 0px;
  }
`;
export const IconWrapper = styled.div`
  padding-top: 3px;
  padding-bottom: 3px;
`;
export const ItemText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  margin-left: 5px;
  color: ${(p) => p.theme.palette.NL800};
`;
export const ListingItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListingItem = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.palette.D400};
  background-color: ${({ theme }) => theme.palette.NL20};
  font-weight: 300;
  font-size: 14px;
  line-height: 19px;
  padding: 7px 8px;
  border-radius: 8px;
`;
export const TooltipContainer = styled.div`
  cursor: pointer;
  .rc-tooltip-content {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.palette.lynxWhite};
    box-shadow: 1px 1px 10px 1px rgba(0, 0, 0, 0.15);
  }

  .rc-tooltip {
    background-color: transparent !important;
    background: transparent !important;
  }
`;
